/**
 * Este servicio tiene 2 responsabilidades principales
 * - Brindar acceso al carrito desde cualquier módulo para abrirlo / cerrarlo / consultarlo / actualizarlo
 * - Acumular toda la información (Operation) del proceso completo para poder recuperarla facilmente desde un punto centralizado
 */


import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {MatStepper} from '@angular/material/stepper';
import {ShoppingCart} from '../classes/ShoppingCart';

@Injectable({
    providedIn: 'root'
})
export class ShoppingCartService {
    private stepper = null;
    private shoppingCart = new ShoppingCart();

    private showCartSubject = new BehaviorSubject(false);
    private updateCartSubject = new BehaviorSubject([]);
    private monthlyTotalSubject = new BehaviorSubject(0);
    private initialTotalSubject = new BehaviorSubject(0);
    private monthlyDiscountSubject = new BehaviorSubject(0);

    public showCartSubscription = this.showCartSubject.asObservable();
    public updateSubscrition = this.updateCartSubject.asObservable();
    public monthlyTotalSubscription = this.monthlyTotalSubject.asObservable();
    public initialTotalSubscription = this.initialTotalSubject.asObservable();
    public monthlyDiscountSubscription = this.monthlyDiscountSubject.asObservable();

    constructor() { }

    showCart(show = true) {
        this.showCartSubject.next(show);
    }

    getShoppingCart() {
        return this.shoppingCart;
    }

    hideCart() {
        this.showCartSubject.next(false);
    }

    updateCart(data) {
        this.updateCartSubject.next(data);
    }

    setMonthlyTotal(monthlyTotal) {
        this.monthlyTotalSubject.next(monthlyTotal);
    }

    setInitialTotal(initialTotal) {
        this.initialTotalSubject.next(initialTotal);
    }

    addItem(item) {
        // todo: add item to cart
    }

    setStepper(stepper: MatStepper) {
        this.stepper = stepper;
    }

    getStepper() {
        return this.stepper;
    }

    getOperationData() {
        return this.shoppingCart.getOperation().getAll();
    }

    generateOrders() {
        return this.shoppingCart.getOperation().generateOrders();
    }

    clearShoppinCart() {
        this.setMonthlyTotal(0);
        this.setInitialTotal(0);
        this.shoppingCart = new ShoppingCart();
    }

    setPdv(pdv) {
        this.shoppingCart.setPdv(pdv);
    }

    setMonthlyDiscount(data) {
        this.monthlyDiscountSubject.next(data);
    }
}
